module.exports = __webpack_public_path__ + "img/xchengxu.db462f6e.png";